import { AnyAction } from "redux";
import { call, put, takeLatest } from "redux-saga/effects";

import { MessageResponse } from "../../../_helpers/iResponse";
import * as Constants from "../constants";
import { IDwelling, IResponseDwelling, IResponseDwellings } from "../reducers";
import * as Services from "../services";

function* addDwelling(action: AnyAction) {
  try {
    const { id }: { id: string } = yield call(
      Services.addDwelling,
      action.dwelling,
    );

    if (id) {
      return action.resolve(id);
    } else {
      return action.reject(false);
    }
  } catch (e) {
    yield put({ type: Constants.ADD_DWELLING_FAILED, e });
    return action.reject(e);
  }
}

function* getDwelling(action: AnyAction) {
  try {
    const payload: IDwelling = yield call(Services.getDwellingInfos, action.id);
    yield put({
      type: Constants.GET_DWELLING_SUCCESS,
      payload,
    });
    return action.resolve(payload.id);
  } catch (e) {
    yield put({ type: Constants.GET_DWELLING_FAILED, e });
    return action.reject(e);
  }
}

function* getDwellings(action: AnyAction) {
  try {
    const payload: IResponseDwellings = yield call(
      Services.getDwellings,
      action.page,
      action.filter.trim(),
    );

    yield put({
      type: Constants.GET_DWELLINGS_SUCCESS,
      payload,
    });
    return action.resolve(true);
  } catch (e) {
    yield put({ type: Constants.GET_DWELLINGS_FAILED, e });
    return action.reject(e);
  }
}

function* updateDwelling(action: AnyAction) {
  try {
    const payload = yield call(Services.updateDwelling, action.dwelling);

    yield put({
      type: Constants.UPDATE_DWELLING_SUCCESS,
      payload: {
        ...payload,
        dwelling: action.dwelling,
      },
    });
    return action.resolve(payload.id);
  } catch (e) {
    yield put({ type: Constants.UPDATE_DWELLING_FAILED, e });
    return action.reject(e);
  }
}

function* getDwellingServices(action: AnyAction) {
  try {
    const { error, data }: IResponseDwelling = yield call(
      Services.getDwellingServices,
      action.page,
      action.dwellingId,
    );

    if (data.message === MessageResponse.OK) {
      yield put({
        type: Constants.GET_DWELLING_SERVICES_SUCCESS,
        payload: data.data,
      });
      return action.resolve(true);
    } else {
      return action.reject(error);
    }
  } catch (e) {
    yield put({ type: Constants.GET_DWELLING_SERVICES_FAILED, e });
    return action.reject(e);
  }
}

function* getDwellingServicesInventory(action: AnyAction) {
  try {
    const { error, data }: IResponseDwelling = yield call(
      Services.getDwellingServicesInventory,
      action.page,
      action.dwellingId,
      action.types,
    );

    if (data.message === MessageResponse.OK) {
      yield put({
        type: Constants.GET_DWELLING_SERVICES_INVENTORY_SUCCESS,
        payload: data.data,
      });
      return action.resolve(true);
    } else {
      return action.reject(error);
    }
  } catch (e) {
    yield put({ type: Constants.GET_DWELLING_SERVICES_INVENTORY_FAILED, e });
    return action.reject(e);
  }
}

function* uploadDwellingFiles(action: AnyAction) {
  try {
    const payload = yield call(
      Services.uploadDwellingFiles,
      action.id,
      action.files,
    );

    yield put({
      type: Constants.UPLOAD_DWELLING_FILES_SUCCESS,
      payload: {
        ...payload,
        dwelling: action.dwelling,
      },
    });
    return action.resolve(payload);
  } catch (e) {
    yield put({ type: Constants.UPLOAD_DWELLINGS_FILES_FAILED, e });
    return action.reject(e);
  }
}

function* removeDwellingFile(action: AnyAction) {
  try {
    const payload = yield call(
      Services.removeDwellingFile,
      action.dwellingId,
      action.fileId,
    );

    yield put({
      type: Constants.REMOVE_DWELLING_FILE_SUCCESS,
      payload: {
        ...payload,
      },
    });
    return action.resolve(payload);
  } catch (e) {
    yield put({ type: Constants.REMOVE_DWELLING_FILE_FAILED, e });
    return action.reject(e);
  }
}

export const dwellingSagas = [
  takeLatest(Constants.ADD_DWELLING, addDwelling),
  takeLatest(Constants.GET_DWELLING, getDwelling),
  takeLatest(Constants.GET_DWELLINGS, getDwellings),
  takeLatest(Constants.UPDATE_DWELLING, updateDwelling),
  takeLatest(Constants.GET_DWELLING_SERVICES, getDwellingServices),
  takeLatest(Constants.UPLOAD_DWELLING_FILES, uploadDwellingFiles),
  takeLatest(Constants.REMOVE_DWELLING_FILE, removeDwellingFile),
  takeLatest(
    Constants.GET_DWELLING_SERVICES_INVENTORY,
    getDwellingServicesInventory,
  ),
];
